export default {"src":"/_next/static/media/asurion-logo.acfc9e74.svg","height":32,"width":121,"blurWidth":0,"blurHeight":0};